export default "__VITE_ASSET__wNYXxTgp__"